module.exports = __webpack_public_path__ + "img/info.72b6211d.svg";